module.exports = __webpack_public_path__ + "static/media/29ADMSPC21.520f58c7.jpg";